import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=0c98f45f&scoped=true&"
var script = {}
import style0 from "./Divider.vue?vue&type=style&index=0&id=0c98f45f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c98f45f",
  null
  
)

export default component.exports